import type {
  UploadFileTypesBlacklist,
  UploadFileTypesWhitelist,
} from "./upload-file.type";

export const UPLOAD_MAX_FILE_SIZE = 50;

export const UPLOAD_FILE_TYPES_BLACKLIST: UploadFileTypesBlacklist = [
  ".bat", // application/x-msdownload
  ".cmd", // ???
  ".doc", // application/msword
  ".docm", // application/vnd.ms-word.document.macroenabled.12
  ".exe", // application/x-msdos-program
  ".html", // text/html
  ".js", // text/javascript
  ".jsp", // ???
  ".php", // application/x-httpd-php
  ".ps1", // ???
  ".sh", // application/x-sh
  ".xls", // application/vnd.ms-excel
  ".xlsm", // application/vnd.ms-excel.sheet.macroenabled.12
];

export const UPLOAD_FILE_TYPES_WHITELIST: UploadFileTypesWhitelist = {
  document: [
    ".pdf", // application/pdf
    ".docx", // application/vnd.openxmlformats-officedocument.wordprocessingml.document
    ".xlsx", // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    ".csv", // text/csv
    ".ppt", // application/vnd.ms-powerpoint
    ".pptx", // application/vnd.openxmlformats-officedocument.presentationml.presentation
    ".txt", // text/plain
    ".vsd", // application/vnd.visio (diagram files produced by Microsoft Visio)
  ],
  drawing: [
    ".dwf", // drawing/x-dwf
    ".dwg", // application/acad (up-to-date type) & image/x-dwg (obsolete type)
    ".dxf", // image/x-dxf
  ],
  image: [
    ".jpg", // image/jpeg
    ".jpeg", // image/jpeg
    ".png", // image/png
    ".gif", // image/gif
  ],
  archive: [
    ".rar", // application/x-rar-compressed
    ".zip", // application/zip
  ],
  video: [
    ".avi", // video/x-msvideo
    ".mp4", // video/mp4
    ".3gp", // video/3gpp
    ".mpeg", // video/mpeg
    ".webm", // video/webm
  ],
  audio: [
    ".mp3", // audio/mpeg
    ".3gpp", // audio/3gpp
    ".adts", // audio/aac
    ".mpga", // audio/mpeg
    ".oga", // audio/ogg
    ".wav", // audio/x-wav
    ".weba", // audio/webm
  ],
};
